import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, defineProperty as _defineProperty, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo } from 'react';
import classnames from 'classnames';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children", "lg", "md", "offset", "pull", "push", "size", "sm", "xs", "xl"];
var _templateObject;
var StyledDiv = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &&& {\n    ", "\n  }\n"])), function (_ref) {
  var grid = _ref.theme.grid;
  return (grid === null || grid === void 0 ? void 0 : grid.gutterSize) && "padding-left: ".concat(grid.gutterSize, ";\n       padding-right: ").concat(grid.gutterSize, ";\n      ");
});
var Col = function Col(props) {
  var children = props.children,
    lg = props.lg,
    md = props.md,
    offset = props.offset,
    pull = props.pull,
    push = props.push,
    size = props.size,
    sm = props.sm,
    xs = props.xs,
    xl = props.xl,
    rest = _objectWithoutProperties(props, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  // TODO: Is there a better way?? ¯\_(ツ)_/¯ (leaving this in here because Doug did it)
  var customPropsArray = Object.keys(props).filter(function (item) {
    return item !== 'children' && item !== 'classNames' && item !== 'styles' && props[item] !== null;
  });
  var classes = classnames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    col: !customPropsArray.length
  }, "col-".concat(size), size), "col-sm-".concat(sm), sm), "col-md-".concat(md), md), "col-lg-".concat(lg), lg), "col-xl-".concat(xl), xl), "push-".concat(push), push), "pull-".concat(pull), pull), "offset-".concat(offset), offset), className);
  return /*#__PURE__*/React.createElement(StyledDiv, _extends({}, rest, {
    className: classes,
    style: style
  }), children);
};
var index = /*#__PURE__*/memo(Col);

export default index;
export { Col };
